__turbopack_context__.v({
  "cardAnimation": "focusAreas-module__VgrSFq__cardAnimation",
  "fadeInUp": "focusAreas-module__VgrSFq__fadeInUp",
  "headerAnimation": "focusAreas-module__VgrSFq__headerAnimation",
  "sectionAnimation": "focusAreas-module__VgrSFq__sectionAnimation",
});
